import { UploadPdfPayload, UploadPdfResponse } from './upload-pdf.types';
import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

export async function uploadPdfService({ body }: UploadPdfPayload) {
  const formData = new FormData();

  formData.append('inputFile', body.inputFile);

  const { response, data } = await BACKEND.raw.post<UploadPdfResponse>(ENDPOINT.OCR_EXTRACTION, {
    body: formData,
  });

  return {
    response,
    summary: data,
  };
}
